export default {
      id: "trophy-usage",
      viewBox: "0 0 75 74",
      url: __webpack_public_path__ + "img/iconaf3563da19c86b00e5da1e83cc285294.svg#trophy",
      toString: function () {
        return this.url;
      }
    }